module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "sgc-toc-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/06_part01"
    }
  }, [_c('i', [_vm._v("Part I")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/07_prologue"
    }
  }, [_vm._v("A Prologue")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/08_ch01"
    }
  }, [_vm._v("A Tree to Be Desired")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/09_ch02"
    }
  }, [_vm._v("While We Waited for You to Be Born")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/10_ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Carnival of the Stoned Children")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/11_ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mississippi")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/12_ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Miss Crystal Confronts the Past")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/13_ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Sordid Tale, or, Traceleen Continues Talking")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/14_ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Phyladda, or, The Mind/Body Problem")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/15_ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Battle")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/16_part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Part I")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/17_ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Triumph of Reason")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/18_ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Have a *Wonderful* Nice Walk")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/19_ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Witness to the Crucifixion")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/20_ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ocean Springs")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/21_part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Part III   Abstract and Brief Chronicles of the Times")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/22_ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excitement at Drake Field")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/23_ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Lady with Pearls")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/24_ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excitement in Audubon Park")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/25_ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Free Pull")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/26_ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Down at the Dollhouse")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/27_ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Southwest Experimental Fast Oxide Reactor")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/MoreFrom",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also by Ellen Gilchrist")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ConnectWithDB",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Connect with Diversion Books")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45546686","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/TOC.vue
// module id = 66
// module chunks = 0